export const GRUPOS_CAT = [
  { grupo: "Estructura",     items: ["Cemento","Acero/Fierro","Fierro corrugado","Precast","Concreto"] },
  { grupo: "Albañilería",    items: ["Ladrillo","Bloquetas","Cal","Mortero"] },
  { grupo: "Áridos",         items: ["Arena fina","Arena gruesa","Piedra chancada","Afirmado","Hormigón"] },
  { grupo: "Acabados",       items: ["Pintura","Cerámicos","Porcelanatos","Enchapes","Yeso"] },
  { grupo: "Instalaciones",  items: ["Tubería PVC","Inst. eléctricas","Inst. sanitarias","Cables"] },
  { grupo: "Madera",         items: ["Madera","Triplay","Puertas/Ventanas","Drywall"] },
  { grupo: "Herramientas",   items: ["Herramientas","Equipos","EPP","Andamios"] },
  { grupo: "Otros",          items: ["Otros"] },
];

export const INICIAL = {
  nombreComercial: "", nombre: "", ruc: "", direccion: "", ciudad: "Lima", website: "",
  categorias: [],
  contactos: [],
  plazoDias: "", creditoDias: "",
  calificacion: "5", notas: "",
};

export const CONTACTO_INIT = { nombre: "", cargo: "", zona: "", telefono: "", email: "" };

export const TOKEN_SUNAT = process.env.REACT_APP_SUNAT_TOKEN;

export const lbl = { display: "block", fontSize: 11, fontWeight: 600, color: "#475569", marginBottom: 5 };
export const inp = { width: "100%", padding: "9px 12px", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 13, color: "#1e293b", outline: "none", background: "#fff", fontFamily: "inherit", boxSizing: "border-box" };
